import { useSnapCarousel } from "react-snap-carousel";
import HeroBanner from "components/herobanner";
import Footer from "components/global/footer";
import { Helmet } from "react-helmet";

const enhancementPoints = [
  {
    id: 0,
    title: "Vision",
    description:
      "To become India’s leading platform for surplus food redistribution, inspiring a nationwide movement towards zero food waste. Through innovation and community engagement, Surpeats envisions a future where every meal is valued, waste is minimized, and affordable, high-quality food is available for all.",
    icon: (
      <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.899658"
          width="63.0128"
          height="63.2669"
          rx="4.79294"
          fill="#3A778A"
        />
        <path
          d="M27.5201 38.2474C27.1287 38.2474 26.8041 37.9214 26.8041 37.5284V35.5441C26.8041 35.1511 27.1287 34.8252 27.5201 34.8252C27.9116 34.8252 28.2362 35.1511 28.2362 35.5441V37.5284C28.2362 37.931 27.9116 38.2474 27.5201 38.2474Z"
          fill="white"
        />
        <path
          d="M32.4084 38.2473C32.017 38.2473 31.6924 37.9214 31.6924 37.5284V33.5502C31.6924 33.1572 32.017 32.8313 32.4084 32.8313C32.7999 32.8313 33.1245 33.1572 33.1245 33.5502V37.5284C33.1245 37.931 32.7999 38.2473 32.4084 38.2473Z"
          fill="white"
        />
        <path
          d="M37.2966 38.2472C36.9052 38.2472 36.5806 37.9213 36.5806 37.5283V31.5659C36.5806 31.1728 36.9052 30.8469 37.2966 30.8469C37.6881 30.8469 38.0127 31.1728 38.0127 31.5659V37.5283C38.0127 37.9309 37.6976 38.2472 37.2966 38.2472Z"
          fill="white"
        />
        <path
          d="M27.5202 32.764C27.1956 32.764 26.9092 32.5436 26.8232 32.2176C26.7278 31.8342 26.9569 31.4412 27.3483 31.3453C30.8618 30.4634 33.9551 28.5366 36.3134 25.7855L36.7525 25.2679C37.0103 24.9707 37.459 24.9324 37.7646 25.1912C38.0605 25.45 38.0987 25.9005 37.8409 26.2073L37.4018 26.7249C34.8526 29.7157 31.4919 31.7959 27.6921 32.7449C27.6348 32.764 27.5775 32.764 27.5202 32.764Z"
          fill="white"
        />
        <path
          d="M37.2966 29.2558C36.9052 29.2558 36.5806 28.9298 36.5806 28.5368V26.4567H34.4993C34.1078 26.4567 33.7832 26.1308 33.7832 25.7377C33.7832 25.3447 34.1078 25.0188 34.4993 25.0188H37.2966C37.6881 25.0188 38.0127 25.3447 38.0127 25.7377V28.5464C38.0127 28.9394 37.6976 29.2558 37.2966 29.2558Z"
          fill="white"
        />
        <path
          d="M35.2727 41.9378H29.5442C24.36 41.9378 22.145 39.7139 22.145 34.5087V28.7572C22.145 23.5521 24.36 21.3281 29.5442 21.3281H35.2727C40.4569 21.3281 42.6719 23.5521 42.6719 28.7572V34.5087C42.6719 39.7139 40.4569 41.9378 35.2727 41.9378ZM29.5442 22.766C25.1429 22.766 23.5771 24.3381 23.5771 28.7572V34.5087C23.5771 38.9278 25.1429 40.4999 29.5442 40.4999H35.2727C39.674 40.4999 41.2398 38.9278 41.2398 34.5087V28.7572C41.2398 24.3381 39.674 22.766 35.2727 22.766H29.5442Z"
          fill="white"
        />
        <ellipse
          cx="52.4581"
          cy="13.4207"
          rx="2.86422"
          ry="2.87577"
          fill="#FF8057"
        />
        <path
          d="M17.6079 48.4088C17.6079 49.9988 16.3246 51.2845 14.7456 51.2845C13.1667 51.2845 11.8833 49.9988 11.8833 48.4088C11.8833 46.8187 13.1667 45.533 14.7456 45.533C16.3246 45.533 17.6079 46.8187 17.6079 48.4088Z"
          stroke="#FFD05B"
          strokeWidth="0.958589"
        />
      </svg>
    ),
  },
  {
    id: 1,
    title: "Mission",
    description:
      "Surpeats is committed to bridging the gap between food waste and food accessibility by connecting consumers with surplus, high-quality meals at discounted prices. We aim to foster a sustainable food ecosystem, empower local businesses, and contribute to a healthier planet by minimizing waste and maximizing the value of food resources.",
    icon: (
      <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.341431"
          width="63.0128"
          height="63.2669"
          rx="4.79294"
          fill="#3A778A"
        />
        <path
          d="M37.6741 37.1448H26.0263C23.8113 37.1448 22.5415 35.8699 22.5415 33.646V22.0471C22.5415 21.654 22.8661 21.3281 23.2576 21.3281H40.4429C40.8343 21.3281 41.1589 21.654 41.1589 22.0471V33.646C41.1589 35.8699 39.8891 37.1448 37.6741 37.1448ZM23.9736 22.766V33.646C23.9736 35.0743 24.6037 35.707 26.0263 35.707H37.6646C39.0871 35.707 39.7173 35.0743 39.7173 33.646V22.766H23.9736Z"
          fill="white"
        />
        <path
          d="M41.3976 22.766H22.3028C21.9114 22.766 21.5868 22.4401 21.5868 22.0471C21.5868 21.654 21.9114 21.3281 22.3028 21.3281H41.3976C41.7891 21.3281 42.1137 21.654 42.1137 22.0471C42.1137 22.4401 41.7891 22.766 41.3976 22.766Z"
          fill="white"
        />
        <path
          d="M28.0315 41.9379C27.7642 41.9379 27.516 41.7941 27.3918 41.5448C27.2104 41.1902 27.3537 40.7588 27.7165 40.5767L31.1344 38.8608V36.426C31.1344 36.033 31.459 35.707 31.8505 35.707C32.2419 35.707 32.5665 36.033 32.5665 36.426V39.3017C32.5665 39.5701 32.4138 39.8194 32.1655 39.944L28.3466 41.8612C28.2511 41.9091 28.1365 41.9379 28.0315 41.9379Z"
          fill="white"
        />
        <path
          d="M35.6692 41.9377C35.5642 41.9377 35.4496 41.909 35.3541 41.8611L31.5352 39.9439C31.1819 39.7618 31.0387 39.3304 31.2105 38.9757C31.3919 38.621 31.8216 38.4772 32.1748 38.6498L35.9938 40.567C36.347 40.7491 36.4902 41.1804 36.3184 41.5351C36.1847 41.7939 35.927 41.9377 35.6692 41.9377Z"
          fill="white"
        />
        <path
          d="M27.5538 31.3931C27.3533 31.3931 27.1433 31.3069 27 31.1343C26.7423 30.8276 26.79 30.377 27.0955 30.1182L30.1029 27.5971C30.3798 27.3671 30.7331 27.2712 31.0672 27.3287C31.4109 27.3862 31.7069 27.5971 31.8883 27.9039L32.8908 29.5814L35.6881 27.2425C35.9937 26.9932 36.4424 27.0316 36.7002 27.3383C36.9579 27.645 36.9102 28.0956 36.6047 28.3544L33.5973 30.8755C33.3204 31.1056 32.9672 31.2014 32.633 31.1439C32.2893 31.0864 31.9933 30.8755 31.8119 30.5688L30.8094 28.8912L28.0121 31.2302C27.8784 31.3356 27.7161 31.3931 27.5538 31.3931Z"
          fill="white"
        />
        <ellipse
          cx="51.8999"
          cy="13.4207"
          rx="2.86422"
          ry="2.87577"
          fill="#FF8057"
        />
        <path
          d="M17.0575 47.4146C17.0575 49.0047 15.7742 50.2904 14.1952 50.2904C12.6162 50.2904 11.3329 49.0047 11.3329 47.4146C11.3329 45.8246 12.6162 44.5389 14.1952 44.5389C15.7742 44.5389 17.0575 45.8246 17.0575 47.4146Z"
          stroke="#FFD05B"
          strokeWidth="0.958589"
        />
      </svg>
    ),
  },
];

const bussinessPonits = [
  {
    id: 0,
    title: "Our Business Model",
    description: `We’re committed to a triple-win approach: benefiting people, driving profits, and protecting the planet. By rescuing surplus food, we enable businesses to earn from unsold items, give consumers access to great food deals, and empower our community to take action against food waste."`,
    img: "images/bussiness-points.jpg",
  },
  {
    id: 1,
    title: "Positive impact",
    description: `Surpeats creates a positive impact by tackling food waste, a major global challenge, while supporting local businesses in India. The platform not only prevents perfectly good food from going to waste but also helps partners reduce losses and reach new customers. This innovative approach promotes sustainability, saves resources, and fosters a community-driven effort to make a meaningful difference in reducing food waste and environmental harm.`,
    img: "images/handsome-man-nature.jpg",
  },
  {
    id: 2,
    title: "Redistributing Surplus Food",
    description: `Surpeats partners with restaurants, bakeries, and cafes to offer surplus food at discounted prices. This prevents good food from being discarded, turning potential waste into meals for those who value quality food at lower prices.`,
    img: "images/food-distribution.png",
  },
  {
    id: 3,
    title: "Empowering Local Businesses",
    description: `By selling surplus food through Surpeats, businesses minimize losses on unsold inventory and reduce disposal costs. They’re able to reach new customers who appreciate sustainability, helping them expand their customer base and maximize resources`,
    img: "images/store-with-man.jpg",
  },
  {
    id: 4,
    title: "Affordable Options for Consumers",
    description: `By selling surplus food through Surpeats, businesses minimize losses on unsold inventory and reduce disposal costs. They’re able to reach new customers who appreciate sustainability, helping them expand their customer base and maximize resources`,
    img: "images/sale-concept.jpg",
  },
];

const teamMembers = [
  {
    id: 1,
    name: "Sonu Bisht",
    role: "(The Founder & CEO Who Started It All, Leading the Charge Against Food Waste)",
    image: "images/testimonial-1.jpg",
  },
  {
    id: 2,
    name: "Rajat Singh Rathod",
    role: `(The Founder & COO Who Joined Forces to Make It Happen, Turning Vision into Reality)`,
    image: "images/testimonial-2.jpg",
  },
  {
    id: 3,
    name: "Saurabh Rai",
    role: `Man behind Finance & Legal`,
    image: "images/testimonial-3.jpg",
  },
  {
    id: 4,
    name: `Smit Kevadiya`,
    role: `Our Tech Guy`,
    image: "images/testimonial-4.jpg",
  }
];

export default function AboutUs() {
  const { pages, scrollRef, goTo, activePageIndex } = useSnapCarousel();

  return (
    <>
      <Helmet>
        <title>About us</title>
      </Helmet>
      <HeroBanner
        showAppLogoInHeader={false}
        sectionClassName="pt-36 pb-16 lg:py-28"
        heroBannerImgUrl="images/about-us-hero-banner.png"
        title={`Our dream is a sustainable world without food waste.`}
        titleClassName="text-left text-4xl lg:text-5xl"
        titleWrapperClassName="lg:max-w-60 text-left lg:ml-auto"
      />
      <section className="py-10  lg:py-20">
        <div className="container">
          <div className="grid grid-cols-1 gap-7 sm:gap-8 sm:grid-cols-2">
            {enhancementPoints.map((item, index) => {
              return (
                <div
                  key={`enhancementPoints-${index}`}
                  className="p-4 rounded-lg shadow-md lg:px-6 lg:py-10"
                >
                  <div className="flex items-center gap-5 mb-4">
                    {item.icon}
                    <span className="text-3xl font-anton">{item.title}</span>
                  </div>
                  <p className="text-lg text-gray-200 lg:text-xl">
                    {item.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <section className="lg:pb-14">
        <div className="container">
          <div className="flex font-anton flex-col md:flex-row">
            <div className="w-full md:w-2/5 bg-primary-200 px-3 py-5 md:pt-2.5 md:pr-2 md:pb-24 md:pl-14 space-y-4 text-xs md:text-base text-white font-anton">
              <h3 className="text-center md:text-right mr-0.5 mb-5 md:mb-8 text-xl md:text-5xl">
                Our first Step{" "}
                <span className="inline-block text-black md:hidden">
                  towards
                </span>{" "}
                <span className="inline-block md:hidden">Sustainability</span>
              </h3>
              <p>
                Our founder, <span className="text-black">SONU BISHT,</span> was
                the driving force behind bringing the concept of tackling food
                waste to India. While working in the quick commerce industry in
                <span className="text-black"> Germany</span>, Sonu observed
                significant food wastage within the food sector. This prompted
                him to reflect on the food waste challenges in{" "}
                <span className="text-black">India</span>.
              </p>
              <p>
                After months of in-depth{" "}
                <span className="text-black">research</span>, Sonu was inspired
                by <span className="text-black">European</span> companies
                leading the fight against food waste and decided to bring a
                similar initiative to <span className="text-black">India</span>.
                With a vision to address this pressing issue, he founded{" "}
                <span className="text-black">SURPEATS</span>—a platform built on
                the powerful idea of reducing food waste while making{" "}
                <span className="text-black">surplus</span> food both accessible
                and affordable.
              </p>
              <p>
                <span className="text-black">SURPEATS</span> connects people and
                businesses with a shared{" "}
                <span className="text-black">mission</span>: to create a
                meaningful impact by turning surplus into{" "}
                <span className="text-black">opportunity</span> and waste into
                value.
              </p>
            </div>
            <div
              className="relative w-full md:max-w-[200px] h-96 md:h-auto max-h-full bg-blue-100"
              style={{
                backgroundImage: `url("images/still-life-sustainable-lifestyle-elements-composition.jpg")`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <h3 className="absolute top-2.5 left-1/2 -translate-x-1/2 text-5xl hidden md:block">
                towards
              </h3>
            </div>
            <div
              className="relative w-full md:w-2/5 h-80 md:h-auto max-h-full bg-red-500"
              style={{
                backgroundImage: `url("images/cropped-image-man-holding-plant.jpg")`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <h3 className="absolute top-2.5 text-5xl text-white hidden md:block">
                Sustainability
              </h3>
            </div>
          </div>
        </div>
      </section>
      <section className="pt-7 pb-8 lg:pt-14 lg:pb-20">
        <div className="container">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {bussinessPonits.map((item, index) => {
              return (
                <div
                  key={`bussinessPoints-${index}`}
                  className="h-full flex flex-col-reverse lg:flex-row lg:items-center gap-5 last:lg:col-span-2"
                >
                  <div className="md:h-full">
                    <h4 className="text-2xl uppercase font-anton mb-3">
                      {item.title}
                    </h4>
                    <p className="text-base text-gray-300 mb-auto">
                      {item.description}
                    </p>
                  </div>
                  <img
                    src={item.img}
                    alt={item.title}
                    className="size-44 rounded-2xl"
                  />
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <section className="bg-primary-200 py-16 lg:py-20">
        <div className="container mb-7">
          <div className="w-full text-white text-center mx-auto lg:max-w-4xl">
            <h4 className=" text-4xl mb-2.5 lg:mb-7 lg:text-5xl font-anton">
              Our team
            </h4>
            <p className="text-base">
              Behind every great meal is a passionate team, and at Surpeats,
              we’re no exception! Our crew is a diverse blend of food
              enthusiasts, sustainability warriors, and innovative thinkers, all
              united by a shared goal: to change the way we think about food
              waste.
            </p>
          </div>
          <div
            ref={scrollRef}
            className="flex-1 h-full flex gap-2.5 py-10 xl:gap-8 overflow-x-auto remove-scroll snap-x snap-start max-w-full"
          >
            {teamMembers.map((member) => (
              <div
                key={member.id}
                className="flex flex-col gap-6 min-w-72 max-w-72 xl:min-w-72 xl:max-w-72 w-full p-6 h-auto bg-white rounded-lg shadow-xl"
              >
                <div className="bg-white rounded-lg p-4">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="size-36 object-cover rounded-lg mb-10 mx-auto"
                  />
                  <h5 className="text-xl text-black font-semibold text-center mb-4">
                    {member.name}
                  </h5>
                  <div className="mb-auto">
                    <p className="text-gray-600 text-sm mb-auto text-center">
                      {member.role}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <ul className="flex items-center justify-center gap-4">
            {pages.map((_, i) => (
              <li key={i}>
                <button
                  className={`size-4 rounded-full transition-colors ${
                    activePageIndex === i
                      ? "bg-white/60"
                      : "bg-white hover:bg-white/60"
                  }`}
                  onClick={() => goTo(i)}
                ></button>
              </li>
            ))}
          </ul>
        </div>
      </section>
      <Footer />
    </>
  );
}
